import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { addDepositToOtherStart } from '../../../store/redux-slices/tenants'
import { useState } from 'react'
import { addDepositStart } from '../../../store/redux-slices/tenantCasino'

const useManageMoney = ({ id, handleClose }) => {
  const { loading } = useSelector((state) => state.tenantCasino)
  const dispatch = useDispatch()
  const { userId } = useParams()

  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ])

  const deposit = (data) => {
    dispatch(addDepositStart({
      data: {
        ...data,
        casinoGameId: String(id),
        bonusAmount: String(data?.bonusAmount)
      },
      handleClose
    }))
  }

  return {
    deposit,
    state, setState, loading
  }
}

export default useManageMoney
